"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCardIcon = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../../../../..");
/** This is a very small wrapper around the Icon element
 * It allows us to place it correctly in the grid in ActionCardHeader
 */
const ActionCardIcon = ({ iconName, }) => {
    return react_1.default.createElement(__1.Icon, { name: iconName, size: 4 });
};
exports.ActionCardIcon = ActionCardIcon;
exports.ActionCardIcon.displayName = "ActionCardIcon";
//# sourceMappingURL=ActionCardIcon.js.map